import React, { useState } from 'react';

import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    CircularProgress,
    Divider,
    FormControlLabel,
    Grid,
    IconButton,
    MenuItem,
    Switch,
    TextField,
    Typography
} from '@mui/material';

import { IconArrowLeft, IconBolt, IconDeviceFloppy, IconGripVertical, IconPlus, IconTrash, IconTool } from '@tabler/icons';

import { useHistory, useParams } from 'react-router-dom';

import axios from 'axios';

import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

const hostname = window.location.hostname;
let AGENT_SERVER;

// if (hostname.startsWith('crm.')) {
//     AGENT_SERVER = 'https://apichat.loged.com.br';
// } else {
//     AGENT_SERVER = 'http://127.0.0.1:7000';
// }
if (hostname.startsWith('crm.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('glazzbeauty.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('casamathiola.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('bliveinpets.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('acin.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('braza55.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('po.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('florestavet.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('quimicer.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('imobiliaria.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else {
    AGENT_SERVER = 'http://127.0.0.1:7000';
}

// const AGENT_SERVER = process.env.REACT_APP_AGENT_SERVER || 'http://127.0.0.1:7000';
// const AGENT_SERVER = process.env.REACT_APP_AGENT_SERVER || 'https://apichat.loged.com.br';

const agentApi = axios.create({
    baseURL: AGENT_SERVER
});

agentApi.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

const EXECUTION_TYPES = [
    {
        value: 'http_request',
        label: 'Chamada HTTP'
    },
    {
        value: 'collect_variable',
        label: 'Coletar variável (sem chamada externa)'
    }
];

const USER_TYPES = [
    {
        value: 'system',
        label: 'Sistema'
    },
    {
        value: 'user',
        label: 'Usuário'
    }
];

const CATEGORIES = [
    {
        value: 'unspecified',
        label: 'Não especificada'
    },
    {
        value: 'data',
        label: 'Dados (consulta)'
    },
    {
        value: 'action',
        label: 'Ação (altera algo)'
    },
    {
        value: 'orchestration',
        label: 'Orquestração (delega para outro agente/fluxo)'
    }
];

const CreateTool = () => {
    const history = useHistory();

    const { agentId } = useParams();

    const [loading, setLoading] = useState(false);

    const [status, setStatus] = useState({
        type: '',
        message: ''
    });

    const [tool, setTool] = useState({
        name: '',
        description: '',
        prompt: '',
        parameters_schema: '{}',
        type_user: 'system',
        execution_type: 'http_request',
        endpoint: '',
        category: 'unspecified',
        has_side_effects: true,
        requires_confirmation: false,
        required_permissions: '',
        required_credentials: '',
        required_states: '',
        forbidden_states: '',
        required_variables: '',
        max_executions: '',
        cooldown_seconds: ''
    });

    const [actions, setActions] = useState([
        {
            id: `action-${Date.now()}`,
            name: '',
            config: `{
  "method": "GET",
  "url": "",
  "headers": {
    "Authorization": "Bearer {{token}}",
    "Content-Type": "application/json"
  }
}`
        }
    ]);

    const handleToolChange = (field, value) => {
        setTool((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    const addAction = () => {
        setActions((prev) => [
            ...prev,
            {
                id: `action-${Date.now()}`,
                name: '',
                config: `{
  "method": "GET",
  "url": "",
  "headers": {
    "Content-Type": "application/json"
  }
}`
            }
        ]);
    };

    const removeAction = (id) => {
        setActions((prev) => prev.filter((a) => a.id !== id));
    };

    const updateAction = (id, field, value) => {
        setActions((prev) =>
            prev.map((a) =>
                a.id === id
                    ? {
                          ...a,
                          [field]: value
                      }
                    : a
            )
        );
    };

    const handleDragEnd = (result) => {
        if (!result.destination) return;

        const items = Array.from(actions);

        const [reorderedItem] = items.splice(result.source.index, 1);

        items.splice(result.destination.index, 0, reorderedItem);

        setActions(items);
    };

    const criarTool = async () => {
        setStatus({
            type: '',
            message: ''
        });

        if (!tool.name.trim()) {
            setStatus({
                type: 'error',
                message: 'Digite o nome da ferramenta.'
            });

            return;
        }

        setLoading(true);

        try {
            let parsedSchema = {};

            try {
                parsedSchema = JSON.parse(tool.parameters_schema);
            } catch (e) {
                setStatus({
                    type: 'error',
                    message: 'parameters_schema inválido.'
                });

                setLoading(false);

                return;
            }

            const toList = (value) =>
                value
                    .split(',')
                    .map((item) => item.trim())
                    .filter(Boolean);

            const toIntOrNull = (value) => (value === '' || value === null || value === undefined ? null : parseInt(value, 10));

            const payload = {
                name: tool.name,
                description: tool.description,
                prompt: tool.prompt,
                parameters_schema: parsedSchema,
                type_user: tool.type_user,
                execution_type: tool.execution_type,
                endpoint: tool.endpoint,
                category: tool.category,
                has_side_effects: tool.has_side_effects,
                requires_confirmation: tool.requires_confirmation,
                required_permissions: toList(tool.required_permissions),
                required_credentials: toList(tool.required_credentials),
                required_states: toList(tool.required_states),
                forbidden_states: toList(tool.forbidden_states),
                required_variables: toList(tool.required_variables),
                max_executions: toIntOrNull(tool.max_executions),
                cooldown_seconds: toIntOrNull(tool.cooldown_seconds)
            };

            const toolResponse = await agentApi.post(`/agent/api/v1/agent/${agentId}/aitools/`, payload);

            const toolId = toolResponse.data?.id;

            if (!toolId) {
                throw new Error('Tool ID não retornado.');
            }

            // 'collect_variable' não faz nenhuma chamada externa (só grava os
            // parâmetros recebidos em ConversationState.variables) - não faz
            // sentido pedir Actions (HTTP) pra ela.
            if (tool.execution_type !== 'collect_variable') {
                for (let i = 0; i < actions.length; i++) {
                    const action = actions[i];

                    const actionPayload = {
                        name: action.name,
                        config: action.config,
                        order: `${i + 1}`
                    };

                    await agentApi.post(`/agent/api/v1/aitools/${toolId}/action/`, actionPayload);
                }
            }

            setStatus({
                type: 'success',
                message: 'Ferramenta criada com sucesso.'
            });

            setTimeout(() => {
                history.goBack();
            }, 1200);
        } catch (error) {
            console.error(error);

            setStatus({
                type: 'error',
                message: 'Erro ao criar ferramenta.'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box>
            {/* HEADER */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 4
                }}
            >
                <Box>
                    <Button
                        startIcon={<IconArrowLeft size={18} />}
                        onClick={() => history.goBack()}
                        sx={{
                            mb: 2,
                            textTransform: 'none'
                        }}
                    >
                        Voltar
                    </Button>

                    <Typography
                        variant="h2"
                        sx={{
                            fontWeight: 800,
                            background: 'linear-gradient(90deg, #1976d2, #9c27b0)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent'
                        }}
                    >
                        Criar Ferramenta
                    </Typography>

                    <Typography
                        variant="body2"
                        sx={{
                            color: 'text.secondary',
                            mt: 0.5
                        }}
                    >
                        Configure uma nova ferramenta para o agente
                    </Typography>
                </Box>
            </Box>

            {status.message && (
                <Alert
                    severity={status.type}
                    sx={{
                        mb: 3,
                        borderRadius: '12px'
                    }}
                >
                    {status.message}
                </Alert>
            )}

            <Grid container spacing={4}>
                {/* TOOL */}
                <Grid item xs={12}>
                    <Card
                        sx={{
                            borderRadius: '20px',
                            border: '1px solid #e2e8f0',
                            boxShadow: '0 8px 30px rgba(0,0,0,0.06)'
                        }}
                    >
                        <Box
                            sx={{
                                background: 'linear-gradient(135deg, #1976d2 0%, #9c27b0 100%)',
                                p: 3,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 2
                            }}
                        >
                            <Box
                                sx={{
                                    width: 56,
                                    height: 56,
                                    borderRadius: '16px',
                                    background: 'rgba(255,255,255,0.15)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <IconTool size={30} color="#fff" />
                            </Box>

                            <Box>
                                <Typography
                                    variant="h4"
                                    sx={{
                                        color: '#fff',
                                        fontWeight: 800
                                    }}
                                >
                                    Nova Ferramenta
                                </Typography>

                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: 'rgba(255,255,255,0.85)'
                                    }}
                                >
                                    Configure os dados da ferramenta
                                </Typography>
                            </Box>
                        </Box>

                        <CardContent sx={{ p: 4 }}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Nome"
                                        value={tool.name}
                                        onChange={(e) => handleToolChange('name', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        select
                                        fullWidth
                                        label="Tipo de execução"
                                        value={tool.execution_type}
                                        onChange={(e) => handleToolChange('execution_type', e.target.value)}
                                    >
                                        {EXECUTION_TYPES.map((item) => (
                                            <MenuItem key={item.value} value={item.value}>
                                                {item.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Descrição"
                                        value={tool.description}
                                        onChange={(e) => handleToolChange('description', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Prompt"
                                        value={tool.prompt}
                                        onChange={(e) => handleToolChange('prompt', e.target.value)}
                                    />
                                </Grid>

                                {tool.execution_type !== 'collect_variable' && (
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Endpoint"
                                            value={tool.endpoint}
                                            onChange={(e) => handleToolChange('endpoint', e.target.value)}
                                        />
                                    </Grid>
                                )}

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        select
                                        fullWidth
                                        label="Tipo Usuário"
                                        value={tool.type_user}
                                        onChange={(e) => handleToolChange('type_user', e.target.value)}
                                    >
                                        {USER_TYPES.map((item) => (
                                            <MenuItem key={item.value} value={item.value}>
                                                {item.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        select
                                        fullWidth
                                        label="Categoria"
                                        helperText="Classificação da ferramenta - usada pelo Agent Runtime para organizar/priorizar tools, não altera o comportamento por si só"
                                        value={tool.category}
                                        onChange={(e) => handleToolChange('category', e.target.value)}
                                    >
                                        {CATEGORIES.map((item) => (
                                            <MenuItem key={item.value} value={item.value}>
                                                {item.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>

                                <Grid item xs={12} md={6} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={tool.has_side_effects}
                                                onChange={(e) => handleToolChange('has_side_effects', e.target.checked)}
                                            />
                                        }
                                        label="Tem efeitos colaterais (altera dados externos)"
                                    />
                                </Grid>

                                <Grid item xs={12} md={6} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={tool.requires_confirmation}
                                                onChange={(e) => handleToolChange('requires_confirmation', e.target.checked)}
                                            />
                                        }
                                        label="Exige confirmação do usuário antes de executar"
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Permissões exigidas"
                                        helperText="Separadas por vírgula. Só liberada quando essas flags estiverem marcadas no estado da conversa (ex: identidade_verificada)"
                                        value={tool.required_permissions}
                                        onChange={(e) => handleToolChange('required_permissions', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Credenciais exigidas"
                                        helperText="Chaves de credenciais do App, separadas por vírgula (ex: CRM_URL, CRM_TOKEN)"
                                        value={tool.required_credentials}
                                        onChange={(e) => handleToolChange('required_credentials', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Divider sx={{ my: 1 }} />
                                    <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                                        Disponibilidade dinâmica
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
                                        Controla quando esta ferramenta é oferecida ao modelo, sem depender de instrução no prompt
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Etapas exigidas"
                                        helperText="Só disponível nessas etapas da conversa, separadas por vírgula. Vazio = qualquer etapa"
                                        value={tool.required_states}
                                        onChange={(e) => handleToolChange('required_states', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Etapas proibidas"
                                        helperText="Nunca disponível nessas etapas, separadas por vírgula"
                                        value={tool.forbidden_states}
                                        onChange={(e) => handleToolChange('forbidden_states', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <TextField
                                        fullWidth
                                        label="Variáveis exigidas"
                                        helperText="Só disponível se já coletadas na conversa, separadas por vírgula (ex: email)"
                                        value={tool.required_variables}
                                        onChange={(e) => handleToolChange('required_variables', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <TextField
                                        fullWidth
                                        type="number"
                                        label="Limite de execuções"
                                        helperText="Máximo de vezes por conversa. Deixe vazio para sem limite, use 1 para execução única"
                                        value={tool.max_executions}
                                        onChange={(e) => handleToolChange('max_executions', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <TextField
                                        fullWidth
                                        type="number"
                                        label="Cooldown (segundos)"
                                        helperText="Tempo mínimo entre duas execuções na mesma conversa. Deixe vazio para sem cooldown"
                                        value={tool.cooldown_seconds}
                                        onChange={(e) => handleToolChange('cooldown_seconds', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        minRows={8}
                                        label="Parameters Schema"
                                        helperText={
                                            tool.execution_type === 'collect_variable'
                                                ? 'Cada propriedade declarada aqui vira uma variável da conversa, gravada com o mesmo nome assim que o modelo chamar esta ferramenta (ex: propriedade "nome_pet" grava a variável nome_pet).'
                                                : undefined
                                        }
                                        value={tool.parameters_schema}
                                        onChange={(e) => handleToolChange('parameters_schema', e.target.value)}
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>

                {/* ACTIONS - não fazem sentido pra 'collect_variable' (sem chamada externa) */}
                {tool.execution_type !== 'collect_variable' && (
                    <Grid item xs={12}>
                        <Card
                            sx={{
                                borderRadius: '20px',
                                border: '1px solid #e2e8f0',
                                boxShadow: '0 8px 30px rgba(0,0,0,0.06)'
                            }}
                        >
                            <Box
                                sx={{
                                    p: 3,
                                    borderBottom: '1px solid #e2e8f0',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}
                            >
                                <Box>
                                    <Typography
                                        variant="h4"
                                        sx={{
                                            fontWeight: 800
                                        }}
                                    >
                                        Actions
                                    </Typography>

                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: 'text.secondary'
                                        }}
                                    >
                                        Arraste para alterar a ordem de execução
                                    </Typography>
                                </Box>

                                <Button
                                    variant="contained"
                                    startIcon={<IconPlus size={18} />}
                                    onClick={addAction}
                                    sx={{
                                        borderRadius: '12px',
                                        textTransform: 'none'
                                    }}
                                >
                                    Adicionar Ação
                                </Button>
                            </Box>

                            <CardContent sx={{ p: 3 }}>
                                <DragDropContext onDragEnd={handleDragEnd}>
                                    <Droppable droppableId="actions">
                                        {(provided) => (
                                            <Box ref={provided.innerRef} {...provided.droppableProps}>
                                                {actions.map((action, index) => (
                                                    <Draggable key={action.id} draggableId={action.id} index={index}>
                                                        {(provided) => (
                                                            <Card
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                sx={{
                                                                    mb: 3,
                                                                    borderRadius: '18px',
                                                                    border: '1px solid #e2e8f0',
                                                                    boxShadow: '0 4px 16px rgba(0,0,0,0.04)'
                                                                }}
                                                            >
                                                                <CardContent>
                                                                    <Box
                                                                        sx={{
                                                                            display: 'flex',
                                                                            justifyContent: 'space-between',
                                                                            alignItems: 'center',
                                                                            mb: 2
                                                                        }}
                                                                    >
                                                                        <Box
                                                                            sx={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: 2
                                                                            }}
                                                                        >
                                                                            <Box
                                                                                {...provided.dragHandleProps}
                                                                                sx={{
                                                                                    cursor: 'grab'
                                                                                }}
                                                                            >
                                                                                <IconGripVertical />
                                                                            </Box>

                                                                            <Typography
                                                                                variant="h5"
                                                                                sx={{
                                                                                    fontWeight: 700
                                                                                }}
                                                                            >
                                                                                Ação #{index + 1}
                                                                            </Typography>
                                                                        </Box>

                                                                        <IconButton color="error" onClick={() => removeAction(action.id)}>
                                                                            <IconTrash size={18} />
                                                                        </IconButton>
                                                                    </Box>

                                                                    <Divider
                                                                        sx={{
                                                                            mb: 3
                                                                        }}
                                                                    />

                                                                    <Grid container spacing={3}>
                                                                        <Grid item xs={12}>
                                                                            <TextField
                                                                                fullWidth
                                                                                label="Nome da Action"
                                                                                value={action.name}
                                                                                onChange={(e) =>
                                                                                    updateAction(action.id, 'name', e.target.value)
                                                                                }
                                                                            />
                                                                        </Grid>

                                                                        <Grid item xs={12}>
                                                                            <TextField
                                                                                fullWidth
                                                                                multiline
                                                                                minRows={10}
                                                                                label="Config"
                                                                                value={action.config}
                                                                                onChange={(e) =>
                                                                                    updateAction(action.id, 'config', e.target.value)
                                                                                }
                                                                                sx={{
                                                                                    '& .MuiInputBase-input': {
                                                                                        fontFamily: 'monospace'
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </Grid>
                                                                    </Grid>
                                                                </CardContent>
                                                            </Card>
                                                        )}
                                                    </Draggable>
                                                ))}

                                                {provided.placeholder}
                                            </Box>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                            </CardContent>
                        </Card>
                    </Grid>
                )}

                {/* FOOTER */}
                <Grid item xs={12}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: 2
                        }}
                    >
                        <Button
                            variant="outlined"
                            onClick={() => history.goBack()}
                            sx={{
                                borderRadius: '12px',
                                px: 3,
                                textTransform: 'none'
                            }}
                        >
                            Cancelar
                        </Button>

                        <Button
                            variant="contained"
                            startIcon={loading ? <CircularProgress size={18} color="inherit" /> : <IconDeviceFloppy size={18} />}
                            onClick={criarTool}
                            disabled={loading}
                            sx={{
                                borderRadius: '12px',
                                px: 4,
                                py: 1.2,
                                textTransform: 'none',
                                fontWeight: 700,
                                background: 'linear-gradient(135deg, #1976d2, #9c27b0)',
                                boxShadow: '0 8px 20px rgba(25,118,210,0.3)'
                            }}
                        >
                            {loading ? 'Criando...' : 'Criar Tool'}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default CreateTool;
